import React from 'react';
import right_arrow from '../../../assets/icons/rightarrow.svg';
import left_arrow from '../../../assets/icons/leftarrow.svg';

const GREY_FILTER = '[filter:brightness(0)_saturate(100%)_invert(55%)_sepia(0%)_saturate(0%)_brightness(90%)]';

function Pagination({ currentPage, totalPages, onPageChange }) {
    if (!totalPages || totalPages < 2) return null;

    const getPages = () => {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const pages = [];
        pages.push(1);
        if (currentPage > 3) pages.push('...');
        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            pages.push(i);
        }
        if (currentPage < totalPages - 2) pages.push('...');
        pages.push(totalPages);
        return pages;
    };

    return (
        <div className="flex items-center justify-center gap-1 mt-8 flex-wrap">
            <button
                className={`w-9 h-9 flex items-center justify-center rounded-lg border border-[#EDEDED] bg-white transition-colors ${
                    currentPage === 1 ? 'opacity-40 cursor-not-allowed' : 'hover:border-[#147F26] hover:bg-[#147F26]/5 cursor-pointer'
                }`}
                onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <img src={left_arrow} alt="prev" className={`w-4 h-4 ${GREY_FILTER}`} />
            </button>

            {getPages().map((page, i) =>
                page === '...' ? (
                    <span key={`dots-${i}`} className="w-9 h-9 flex items-center justify-center text-[#939393] text-[13px]">
                        …
                    </span>
                ) : (
                    <button
                        key={page}
                        className={`w-9 h-9 flex items-center justify-center rounded-lg text-[13px] font-medium border transition-colors cursor-pointer ${
                            currentPage === page
                                ? 'bg-[#147F26] border-[#147F26] text-white'
                                : 'bg-white border-[#EDEDED] text-[#222222] hover:border-[#147F26] hover:bg-[#147F26]/5'
                        }`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                )
            )}

            <button
                className={`w-9 h-9 flex items-center justify-center rounded-lg border border-[#EDEDED] bg-white transition-colors ${
                    currentPage === totalPages ? 'opacity-40 cursor-not-allowed' : 'hover:border-[#147F26] hover:bg-[#147F26]/5 cursor-pointer'
                }`}
                onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <img src={right_arrow} alt="next" className={`w-4 h-4 ${GREY_FILTER}`} />
            </button>
        </div>
    );
}

export default Pagination;
